import { Spinner } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import { TextFit } from 'lib-shared-legacy-components';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import styles from './tvDashboardMetric.module.scss';
import { TvDashboardMetricItem } from './tvDashboardMetric.types';

type TvDashboardMetricProps = {
  metric: TvDashboardMetricItem;
  isLoading?: boolean;
} & PropsWithClassName;

export const TvDashboardMetric = memo(function TvDashboardMetric({
  className,
  metric: { title, stat, color = colors.blue[400] },
  isLoading = false,
}: TvDashboardMetricProps): JSX.Element {
  return (
    <div className={classNames(styles.root, className)}>
      {isLoading ? (
        <Spinner
          size={32}
          color={colors.neutral[100]}
          trackColor={colors.neutral[700]}
        />
      ) : (
        <div className={styles.metric}>
          <div className={styles.stat} style={{ color }}>
            {typeof stat === 'string' || typeof stat === 'number' ? (
              <TextFit max={70}>{stat.toString()}</TextFit>
            ) : (
              stat
            )}
          </div>

          <TextFit className={styles.title} max={26}>
            {title}
          </TextFit>
        </div>
      )}
    </div>
  );
});
